export default __webpack_public_path__ + "static/media/equipment.fb087df7.svg";